export function BannerCareer() {
    return (
        <div className="banner">
            <div className="banner-text">
                <h1 className="banner-head">Come join us!</h1>
                <p className="banner-body">We're building the world's first language immersion platform.</p>
                <div className="banner-btn">
                    Jobs
                </div>
            </div>
        </div>
    )
}